import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppBar from "components/layouts/AppBar";
import { usePageTitle } from "context/PageTitleContext";
import ModuleSidebar from "./ModuleSidebar";
import "modules/subcontracts/styles/subcontracts.css";

const AUTO_COLLAPSE_MEDIA_QUERY = "(max-width: 760px)";

export default function ModuleLayout({
  menuItems = [],
  pageHeaders = {},
  defaultHeader = {
    title: "Quản lý",
    subtitle: "",
  },
  getHeader,
  storageKey = "module-sidebar-collapsed",
}) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(storageKey) === "true");
  const location = useLocation();
  const { setPageTitle, setPageSubtitle } = usePageTitle();

  useEffect(() => {
    const configuredHeader = pageHeaders[location.pathname] || defaultHeader;
    const header = getHeader?.(location.pathname, configuredHeader) || configuredHeader;

    setPageTitle(header.title);
    setPageSubtitle(header.subtitle || "");
  }, [defaultHeader, getHeader, location.pathname, pageHeaders, setPageSubtitle, setPageTitle]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const collapseForSmallScreen = () => {
      setCollapsed((value) => {
        if (value) {
          return value;
        }

        localStorage.setItem(storageKey, "true");
        return true;
      });
    };

    const mediaQuery = window.matchMedia(AUTO_COLLAPSE_MEDIA_QUERY);
    const handleMediaQueryChange = (event) => {
      if (event.matches) {
        collapseForSmallScreen();
      }
    };

    if (mediaQuery.matches) {
      collapseForSmallScreen();
    }

    mediaQuery.addEventListener("change", handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, [storageKey]);

  const toggle = () => {
    setCollapsed((value) => {
      localStorage.setItem(storageKey, String(!value));
      return !value;
    });
  };

  return (
    <div className="module-layout subcontract-layout">
      <ModuleSidebar collapsed={collapsed} onToggle={toggle} menuItems={menuItems} />
      <div className={`module-layout__content subcontract-layout__content ${collapsed ? "collapsed" : ""}`}>
        <header className={`module-layout__header subcontract-layout__header ${collapsed ? "collapsed" : ""}`}>
          <AppBar variant="module" />
        </header>
        <main className="module-layout__main subcontract-layout__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
